








import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import {
  getHomeUrl
} from '../../service/auth'
@Component
export default class PreLogin extends Vue {
  public switchyiqi(e) {
    this.setCookie('user_platform', '0', 7*365)
    location.href = 'https://sso.oaloft.com/cas/login?service=' + decodeURI(getHomeUrl())
    //location.reload()
  }

  public switchjinshu(e) {
    this.setCookie('user_platform', '1', 7*365)
    location.href = 'https://sso.jinshuschool.net/cas/login?service=' + decodeURI(getHomeUrl())
    //location.reload()
  }

  private setCookie(cname, cvalue, exdays) {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + '; ' + expires
  }

  // private getHomeUrl() {
  //   return location.protocol + '//' + location.host + '/cguardian/'
  // }
}

